import { BaseEntity } from './base-entity';

export type QueueState =
    'ACTIVE' |
    'BREAK' |
    'INACTIVE' |
    'DISABLED' |
    'DELETED';

export type EnableRegistrationState =
    'ACTIVE' |
    'INACTIVE' |
    'HIDDEN';

export class Queue implements BaseEntity {

    public static MAX_LOGO_SIZE_KB = 800;
    public static MAX_REGISTRATION_PERIOD = 120;
    public static MIN_REGISTRATION_PERIOD = 1;
    public static MAX_REGISTRATION_INTERVAL = 720;
    public static MIN_REGISTRATION_INTERVAL = 1;
    public static MIN_LENGTH_INFO_TO_PRINT = 0;
    public static MAX_LENGTH_INFO_TO_PRINT = 300;
    public static MIN_LENGTH_LABEL_PREFIX = 0;
    public static MAX_LENGTH_LABEL_PREFIX = 3;

    public static MIM_LOGO_WIDTH = 100;
    public static MIM_LOGO_HEIGHT = 100;

    public static DEFAULT_QUEUE_STATE: QueueState = 'INACTIVE';
    public static DEFAULT_REGISTRATION_STATE: EnableRegistrationState = 'INACTIVE';

    constructor(public id?: number,
                public name?: string,
                public description?: string,
                public logoContentType?: string,
                public logo?: any,
                public labelPrefix?: string,
                public infoToPrint?: string,
                public futureVisitPlanningEnabled?: boolean,
                public notPlannedRegistrationEnabled?: boolean,
                public registrationInterval?: number,
                public registrationConfirmPeriod?: number,
                public category?: boolean,
                public state?: QueueState,
                public registration?: EnableRegistrationState,
                public parentId?: number,
                public facultyId?: number) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/queue.model.ts